export default "__VITE_ASSET__31603c14__"